export const isGoldLogistic = process.env.NEXT_PUBLIC_LOGISTIC === '1'

export const addLoadFormStorageKey = 'add_load_form'
